import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import { getAuthorizationHeader, isManarahAuth } from '@/services/auth-token'

async function fetchTwoFactorStatus(token: string): Promise<boolean | null> {
  try {
    const response = await fetch('/v1.0/user/2fa/status', {
      method: 'GET',
      headers: {
        Authorization: getAuthorizationHeader(token) ?? ''
      }
    })

    if (!response.ok) {
      return null
    }

    const data = (await response.json()) as { enabled?: boolean }
    return Boolean(data.enabled)
  } catch {
    return null
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/messages'
      // component: () => import('../views/Messages.vue'),
      // meta: {
      //   requiresAuth: true,
      //   translation: 'الرسائل'
      // }
    },
    {
      path: '/health',
      name: 'health',
      component: () => import('../views/HealthView.vue')
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import('../views/Messages.vue'),
      meta: {
        requiresAuth: true,
        translation: 'الرسائل'
      }
    },
    {
      path: '/servers',
      name: 'servers',
      component: () => import('../views/Servers.vue'),
      meta: {
        requiresAuth: true,
        translation: 'الخوادم'
      }
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('../views/Contacts.vue'),
      meta: {
        requiresAuth: true,
        translation: 'جهات الاتصال'
      }
    },
    {
      path: '/applications',
      name: 'applications',
      component: () => import('../views/Applications.vue'),
      meta: {
        requiresAuth: true,
        translation: 'التطبيقات'
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/Users.vue'),
      meta: {
        requiresAuth: true,
        translation: 'المستخدمين'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/ProfileView.vue'),
      meta: {
        requiresAuth: true,
        translation: 'الملف الشخصي'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        guest: true,
        translation: 'تسجيل الدخول',

        id: 2
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const token = localStorage.getItem('token')

  if (to.meta.requiresAuth && !token) {
    return next({ name: 'login' })
  }

  if (to.meta.guest && token) {
    if (isManarahAuth()) {
      return next({ name: 'messages' })
    }

    const twoFactorEnabled = await fetchTwoFactorStatus(token)

    if (twoFactorEnabled === false) {
      return next({ name: 'profile', query: { enforce_2fa: '1' } })
    }

    return next({ name: 'messages' })
  }

  if (to.meta.requiresAuth && token && !isManarahAuth() && to.name !== 'profile') {
    const twoFactorEnabled = await fetchTwoFactorStatus(token)

    if (twoFactorEnabled === false) {
      return next({ name: 'profile', query: { enforce_2fa: '1' } })
    }
  }

  return next()
})

router.afterEach(async (to) => {
  NProgress.done()

  const token = localStorage.getItem('token')

  if (!token) return

  // Since we don't have user info anymore, we can skip tracking
  // Or implement a different tracking mechanism
  // For now, just complete navigation
})

export default router
